import React from 'react'
import { Route, Switch } from 'react-router-dom'
// import PageLayout from 'layouts/PageLayout'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/utility/utilities'
        render={routeProps => (
          <div>
            {require('./Payment').default(routeProps)}
            {require('./Select').default(routeProps)}
          </div>
        )}
      />
    </Switch>
  )
}

export default AppRouter
